import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { memo } from "react";
import PropTypes from "prop-types";

import { DialogBox } from "components";
import { parseMtValue } from "../makeData";

const FGConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  isExpectedFgSelected,
  confirmationMessage,
  confirmationItems,
  dueDate,
  formatDialogDate,
}) => {
  return (
    <DialogBox
      open={open}
      title={
        isExpectedFgSelected
          ? "Confirm Expected FG Update"
          : "Confirm Bulk FG Update"
      }
      okButtonLabel="Confirm"
      cancelButtonLabel="Cancel"
      handleClose={onClose}
      handleConfirm={onConfirm}
      okButtonSize="small"
      cancelButtonSize="small"
      okButtonVariant="contained"
      cancelButtonVariant="outlined"
      contentStyle={{ px: 6, py: 1 }}
      okButtonStyle={{ minWidth: 100, padding: "8px 12px" }}
      cancelButtonStyle={{ minWidth: 100, padding: "8px 16px" }}
      buttonWrapperStyle={{
        justifyContent: "flex-end",
        gap: 1.5,
        px: 6,
        pt: 4,
        width: "100%",
      }}
      paperProps={{
        sx: {
          width: "auto",
          minWidth: isExpectedFgSelected ? 520 : 400,
        },
      }}
      msgStyle={{
        whiteSpace: "pre-line",
        fontSize: 14,
        lineHeight: 1.6,
      }}
    >
      <Box mb={2} px={2}>
        <Typography variant="body2" color="text.secondary">
          {confirmationMessage}
        </Typography>
      </Box>
      <Box
        sx={{
          minWidth: isExpectedFgSelected ? 520 : 400,
          px: 0,
          py: 1,
        }}
      >
        <TableContainer
          sx={{
            width: "100%",
            mx: "auto",
            border: "1px solid",
            borderColor: "grey.200",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <Table size="small" sx={{ width: "100%" }}>
            <TableHead sx={{ backgroundColor: "grey.100" }}>
              <TableRow>
                <TableCell sx={{ fontWeight: 700, color: "text.secondary" }}>
                  SKU ENDING
                </TableCell>
                {isExpectedFgSelected ? (
                  <>
                    <TableCell
                      sx={{ fontWeight: 700, color: "text.secondary" }}
                    >
                      Expected FG
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: 700, color: "text.secondary" }}
                    >
                      Due date
                    </TableCell>
                  </>
                ) : (
                  <TableCell sx={{ fontWeight: 700, color: "text.secondary" }}>
                    UPDATE
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {confirmationItems.map((item) => {
                const currentFgReady = parseMtValue(item.fgReady);
                const currentExpectedFg = parseMtValue(item.expectedFg);
                const newFgReady = isExpectedFgSelected
                  ? 0
                  : parseMtValue(item.notInvoicedQty);
                const newExpectedFg = isExpectedFgSelected
                  ? parseMtValue(item.notInvoicedQty)
                  : currentExpectedFg;
                const skuEnding = item.id;

                return (
                  <TableRow key={item.id} hover>
                    <TableCell sx={{ fontWeight: 400 }}>{skuEnding}</TableCell>
                    {isExpectedFgSelected ? (
                      <>
                        <TableCell sx={{ fontWeight: 400 }}>
                          {`${currentExpectedFg} → ${newExpectedFg} MT`}
                        </TableCell>
                        <TableCell sx={{ fontWeight: 400 }}>
                          {formatDialogDate(dueDate)}
                        </TableCell>
                      </>
                    ) : (
                      <TableCell sx={{ fontWeight: 400 }}>
                        {`FG ready ${currentFgReady} → ${newFgReady} MT`}
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </DialogBox>
  );
};

FGConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isExpectedFgSelected: PropTypes.bool,
  confirmationMessage: PropTypes.string,
  confirmationItems: PropTypes.array,
  dueDate: PropTypes.string,
  formatDialogDate: PropTypes.func.isRequired,
};

FGConfirmDialog.defaultProps = {
  isExpectedFgSelected: false,
  confirmationMessage: "",
  confirmationItems: [],
  dueDate: "",
};

export default memo(FGConfirmDialog);
